import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faBookMedical } from '@fortawesome/pro-regular-svg-icons/faBookMedical'
import { faHandHoldingMedical } from '@fortawesome/pro-regular-svg-icons/faHandHoldingMedical'
import { faPrescription } from '@fortawesome/pro-regular-svg-icons/faPrescription'
import { getIconByPropertyLabel } from '@modules/drugs/helpers/getIconByPropertyLabel'
import type {
  DrugLabelData,
  DrugOverviewProperty,
} from '@modules/drugs/helpers/getTreatmentPageData'

export const TreatmentProperties = ({
  drugDescription,
  drugLabelData,
  drugName,
  drugOverviewProperties,
}: {
  drugDescription: string | null
  drugLabelData: DrugLabelData | null
  drugName: string
  drugOverviewProperties: DrugOverviewProperty[]
}) => {
  return (
    <>
      {drugOverviewProperties.map((property, key) => (
        <DrugProperty
          description={property.description}
          icon={getIconByPropertyLabel(property.label)}
          key={key}
          label={property.label}
        />
      ))}
      <DrugProperty
        description={'The Generic name of this drug'}
        icon={faHandHoldingMedical}
        label={drugName}
      />
      {drugDescription && (
        <DrugProperty
          description={drugDescription}
          icon={faBookMedical}
          label={'Treatment Summary'}
        />
      )}
      {drugLabelData?.brandName && (
        <DrugProperty
          description={'is the brand name'}
          icon={faPrescription}
          label={drugLabelData.brandName}
        />
      )}
    </>
  )
}

export const DrugProperty = ({
  description,
  icon,
  label,
}: {
  description?: string
  icon: IconDefinition
  label?: string
}) => {
  return (
    <div className='flex py-2'>
      <Icon className='mr-3 mt-2' icon={icon} />
      <div>
        <Text className='mb-1' styleName={'p-small-strong'} value={label} />
        <Text styleName={'p-small'} value={description} />
      </div>
    </div>
  )
}
